import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Button,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

const AgeConfirmModal = ({ isOpen, onConfirm }) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if user has already confirmed their age
    const hasConfirmedAge = localStorage.getItem('ageConfirmed');
    
    if (!hasConfirmedAge && isOpen) {
      setShowModal(true);
    } else if (hasConfirmedAge && isOpen) {
      // If already confirmed, call onConfirm directly
      onConfirm();
    }
  }, [isOpen, onConfirm]);

  const handleConfirm = () => {
    // Store confirmation in localStorage
    localStorage.setItem('ageConfirmed', 'true');
    setShowModal(false);
    onConfirm();
  };

  const handleClose = () => {
    // Redirect to home on X
    history.push("/home");
  };

  return (
    <Modal isOpen={showModal} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="lg" pb={0}>
          Age Confirmation
        </ModalHeader>
        <ModalCloseButton onClick={handleClose} />
        <ModalBody pt={2}>
          <Text fontSize="md">
            I confirm that I am at least 16 years old, or I have permission from
            my parent or legal guardian to use this service.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            bg="#286328"
            textColor="white"
            borderRadius="lg"
            _hover="none"
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AgeConfirmModal;
